import {
  ROLE_STORY_COMMENTOR_CODE,
  ROLE_STORY_EDITOR_CODE,
  ROLE_STORY_OWNER_CODE,
  ROLE_STORY_VIEWER_CODE,
  ROLE_WORKSPACE_ADMIN_CODE,
  ROLE_WORKSPACE_GUEST_CODE,
  ROLE_WORKSPACE_MEMBER_CODE,
  ROLE_WORKSPACE_OWNER_CODE,
} from "../_utils/constants";
import {
  SET_STORY_PERMISSION_CHECKS,
  SET_WORKSPACE_PERMISSION_CHECKS,
} from "./types";

export const setRBWorkspacePermissionCheck = (userDetail) => {
  const permissions = userDetail?.role?.permissions || [];
  const userRole = userDetail?.role;
  const isWorkspaceOwner = userRole?.name === ROLE_WORKSPACE_OWNER_CODE;
  const isWorkspaceAdmin = userRole?.name === ROLE_WORKSPACE_ADMIN_CODE;
  const isWorkspaceMember = userRole?.name === ROLE_WORKSPACE_MEMBER_CODE;
  const isWorkspaceGuestMember = userRole?.name === ROLE_WORKSPACE_GUEST_CODE;

  return {
    type: SET_WORKSPACE_PERMISSION_CHECKS,
    payload: {
      // Story
      canCreateStory: permissions.includes("add_story"),
      canEditStory: permissions.includes("change_story"),
      canDeleteStory: permissions.includes("delete_story"),
      canViewStory: permissions.includes("view_story"),
      canShareStory: !isWorkspaceGuestMember,

      // Brandkit
      canCreateBrandKit: permissions.includes("add_brandkit"),
      canViewBrandKit: permissions.includes("view_brandkit"),
      canEditBrandKit: permissions.includes("change_brandkit"),
      canDeleteBrandKit: permissions.includes("delete_brandkit"),

      // Brandkit Logos
      canCreateBrandKitLogo: permissions.includes("add_logo"),
      canViewBrandKitLogo: permissions.includes("view_logo"),
      canEditBrandKitLogo: permissions.includes("change_logo"),
      canDeleteBrandKitLogo: permissions.includes("delete_logo"),

      // Brandkit fonts
      canCreateBrandKitFont: permissions.includes("add_tldrfont"),
      canViewBrandKitFont: permissions.includes("view_tldrfont"),
      canEditBrandKitFont: permissions.includes("change_tldrfont"),
      canDeleteBrandKitFont: permissions.includes("delete_tldrfont"),

      // Brandkit color palette
      canCreateBrandKitColorPalette: permissions.includes("add_palette"),
      canViewBrandKitColorPalette: permissions.includes("view_palette"),
      canEditBrandKitColorPalette: permissions.includes("change_palette"),
      canDeleteBrandKitColorPalette: permissions.includes("delete_palette"),

      // Settings --> Submenu
      canViewEarnRewards: isWorkspaceOwner,
      canViewConnectedApps: !isWorkspaceGuestMember,
      canEditConnectedApps: isWorkspaceOwner || isWorkspaceAdmin,
      canViewBilling: isWorkspaceOwner || isWorkspaceAdmin,
      canViewWorkspaceSettings: !isWorkspaceGuestMember,

      // Library
      canViewMyLibrary: !isWorkspaceGuestMember,

      // Planner
      canViewPublishing: !isWorkspaceGuestMember,
      canViewPlanner: !isWorkspaceGuestMember,
      canEditAccounts: permissions.includes("manage_accounts"),
      canEditAccountsAll: permissions.includes("manage_accounts_all"),
      canApproveDrafts: permissions.includes("approve_drafts"),
      canEditDrafts: permissions.includes("manage_drafts"),
      canEditDraftsAll: permissions.includes("manage_drafts_all"),
      canEditPosts: permissions.includes("manage_posts"),
      canEditPostsAll: permissions.includes("manage_posts_all"),
      canViewAnalytics: permissions.includes("view_analytics"),
      canEditAnalytics: permissions.includes("manage_analytics"),

      // AI Documents
      canCreateAIDocument: permissions.includes("add_document"),
      canViewAIDocument: permissions.includes("view_document"),
      canEditAIDocument: permissions.includes("change_document"),
      canDeleteAIDocument: permissions.includes("delete_document"),

      // AI Documents --> Copy
      canCreateAIDocumentCopy: permissions.includes("add_copy"),
      canViewAIDocumentCopy: permissions.includes("view_copy"),
      canEditAIDocumentCopy: permissions.includes("change_copy"),
      canDeleteAIDocumentCopy: permissions.includes("delete_copy"),

      // workspace
      canInviteMemberToWorkspace: isWorkspaceOwner || isWorkspaceAdmin,
      canUpdateWorkspaceSettings: isWorkspaceOwner || isWorkspaceAdmin,

      //payments
      canPayViaPaypalButton: permissions.includes("add_invoice"),

      // For feature review
      forFeatureReview: permissions.includes("feature_review"),
    },
  };
};

export const setRBStoryPermissionCheck = (userDetail) => {
  const permissions = userDetail?.role?.permissions || [];
  const userRole = userDetail?.role;
  const isStoryOwner = userRole?.name === ROLE_STORY_OWNER_CODE;
  const isStoryEditor = userRole?.name === ROLE_STORY_EDITOR_CODE;
  const isStoryViewer = userRole?.name === ROLE_STORY_VIEWER_CODE;
  const isStoryCommentor = userRole?.name === ROLE_STORY_COMMENTOR_CODE;

  const isWorkspaceOwner = userRole?.name === ROLE_WORKSPACE_OWNER_CODE;
  const isWorkspaceAdmin = userRole?.name === ROLE_WORKSPACE_ADMIN_CODE;
  const isWorkspaceMember = userRole?.name === ROLE_WORKSPACE_MEMBER_CODE;

  return {
    type: SET_STORY_PERMISSION_CHECKS,
    payload: {
      // Story
      canCreateStory: permissions.includes("add_story"),
      canEditStory: permissions.includes("change_story"),
      canDeleteStory: permissions.includes("delete_story"),
      canViewStory: permissions.includes("view_story"),

      canShareStory:
        isStoryOwner ||
        isStoryEditor ||
        isWorkspaceOwner ||
        isWorkspaceAdmin ||
        isWorkspaceMember,
      canUpdateStoryName:
        isStoryOwner ||
        isStoryEditor ||
        isWorkspaceOwner ||
        isWorkspaceAdmin ||
        isWorkspaceMember,
    },
  };
};
